<template>
    <vx-expandable-card>
        <template v-slot:header>Documentation</template>
        <template v-slot:content>
            <div class="mb-4">
                When the Revel integration is connected, Voxie will sync customer data and order information from your
                Revel point of sale system to automatically create and update contacts in Voxie.
            </div>
            <div class="mb-4">Voxie will collect the following contact data from Revel:</div>
            <ul class="list-disc list-inside mb-4">
                <li>First name</li>
                <li>Last name</li>
                <li>Phone number</li>
                <li>Email</li>
                <li>
                    Contact custom attributes:
                    <ul class="list-disc list-inside pl-4 mt-1">
                        <li><code>last_purchase_date</code></li>
                        <li><code>last_purchase_amount</code></li>
                        <li><code>total_purchases</code></li>
                    </ul>
                </li>
            </ul>
        </template>
    </vx-expandable-card>
</template>

<script setup lang="ts">
import { VxExpandableCard } from '@voxie/frontend-components';
</script>
